export default [{
    value: '',
    label: '全部'
}, {
    value: '0',
    label: '在途'
}, {
    value: '1',
    label: '在途-已分润'
}, {
    value: '2',
    label: '在途-分润失败'
}
];



// WEBPACK FOOTER //
// ./src/service/constant/PlatoonLicenStatus.js